import {BulkDeleteSavedReportMutationResponse, ReportRow} from '../../ReportTypes';
import {MODAL_TYPE, showModal} from '../../../../shared/components/modals/generic_modal_conductor';
import {createToast} from '../../../../shared/components/toasts/another-toast/toaster';
import BulkDeleteSavedReportMutation from '../../../../../mutations/bulk_delete_saved_report_mutation';
import Util from '../../../../shared/util/util';
import {IntlShape} from 'react-intl';

const triggerToast = (result: BulkDeleteSavedReportMutationResponse, intl: IntlShape) => {
	const deletedCount = result.bulkDeleteSavedReport.deletedReportIds.length;
	createToast({
		duration: 5000,
		message: intl.formatMessage({id: 'report.bulk-has-been-deleted'}, {deletedCount: deletedCount}),
	});
};

const modalCallback = (reports: ReportRow[], companyId: string | undefined, intl: IntlShape, successCallback: () => void) => {
	const reportServiceIds = reports.filter(report => report.reportService).map(report => report.id);
	const savedReportIds = reports.filter(report => !report.reportService).map(report => report.id);

	Util.CommitMutation(
		BulkDeleteSavedReportMutation,
		{
			reportServiceIds: reportServiceIds,
			savedReportIds: savedReportIds,
			companyId: companyId,
		},
		(result: BulkDeleteSavedReportMutationResponse) => {
			triggerToast(result, intl);
			successCallback();
		}
	);
};

export const bulkDeleteReports = (
	reports: ReportRow[],
	companyId: string | undefined,
	intl: IntlShape,
	successCallback: () => void
): void => {
	showModal({
		type: MODAL_TYPE.DELETE_REPORT_MODAL,
		reportCount: reports.length,
		callback: () => modalCallback(reports, companyId, intl, successCallback),
	});
};
